<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 09:24:52
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-02-05 15:11:57
-->
<template>
  <div>
    <mrc_ess_iconGroup :is_disabled="readonly"
                       :showReturn="false"
                       :showEdit="hasBtn('edit-serial-number')"
                       :show_del="hasBtn('delete-serial-number')"
                       @handleEdit="handleEdit"
                       @handleDel="handleDel"></mrc_ess_iconGroup>
    <serialNumber :disabled="readonly"
                  @changeReadonly="handleEdit"></serialNumber>
  </div>
</template>
<script>
import { deleteSerialNumber } from '@/service/api/serialNumber.js'
import serialNumber from './serialNumber'
export default {
  components: {
    serialNumber,
  },
  props: {},
  data () {
    return {
      readonly: false,
      list: {},
    }
  },
  computed: {},
  created () { },
  watch: {
    readonly: {
      handler (v) {
        if (!this.$store.state.uuid) return
        if (!v) {
          this.$route.meta.title = 'label_edit_serial_number'
          this.$store.commit('set_page_title', 'label_edit_serial_number')
        }
        else {
          this.$route.meta.title = 'label_view_serial_number'
          this.$store.commit('set_page_title', 'label_view_serial_number')
        }
      }, immediate: true
    }
  },
  mounted () {
    this.readonly = this.$store.state.iconstatus
  },
  beforeDestroy () { },
  methods: {
    handleEdit () {
      this.readonly = !this.readonly
      this.$store.commit('set_iconstatus', this.readonly)
    },
    handleDel () {
      this.$myConfirm({
        content: this.$t('message_Confirm_the_deletion'),
      }).then(() => {
        deleteSerialNumber({ uuid: this.$store.state.uuid }).then((res) => {
          if (res.code == '200') {
            this.$Message({
              text: this.$t('message_The_deletion_was_successful'),
            })

            this.$router.push({
              name: 'serial-number',
              params: {
                type: 'del',
              },
            })
          }
        })
      })
    },
  },
}
</script>

<style scoped></style>
